import { FC, useEffect } from 'react';

import { baseUrl } from '@carcareers/store';

const EXCELSUS_ID_KEY = 'carcareers_excelsus_id';
const REDIRECT_URL = 'https://excelsusdata.com';
const env = process.env.NX_ENVIRONMENT ?? 'dev';

const GoExcelsus: FC = () => {
  useEffect(() => {
    // Persist a UUID per browser so we can deduplicate in the backend
    let id = localStorage.getItem(EXCELSUS_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(EXCELSUS_ID_KEY, id);
    }

    const deviceType = /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
    const apiBase = baseUrl[env as keyof typeof baseUrl] ?? baseUrl.dev;

    // keepalive ensures the request completes even after the page navigates away
    fetch(`${apiBase}/stats/excelsus/track`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        fingerprint: id,
        referrer: document.referrer || '',
        userAgent: navigator.userAgent,
        deviceType,
      }),
    }).catch(() => {
      // Silently fail — tracking errors must never block the redirect
    });

    window.location.replace(REDIRECT_URL);
  }, []);

  return null;
};

export { GoExcelsus };
export default GoExcelsus;
